module.exports = __webpack_public_path__ + "static/img/pre_active.3df78872.jpg";